/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  spacing: {
    0: "0px",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "48px",
    7: "56px",
    8: "64px",
    9: "72px",
    10: "80px",
    11: "88px",
    12: "96px",
    13: "104px",
    14: "112px",
    15: "120px",
    16: "128px",
    17: "136px",
    18: "144px",
    19: "152px",
    20: "160px",
    21: "168px",
    22: "176px",
    23: "184px",
    24: "192px",
    25: "200px",
    "0p5": "4px",
    "0p75": "6px",
    "1p25": "10px",
    "1p5": "12px",
    "0p25": "2px",
    "0p125": "1px",
    "2p5": "20px",
    "3p5": "28px",
    "5p5": "44px",
    "7p5": "60px",
    "6p5": "52px",
    "1p75": "14px",
    factor: "8px",
    "2p25": "18px",
    "0p625": "5px",
    "0p875": "7px",
    "0p375": "3px",
    "1p125": "9px",
    "1p375": "11px",
    "1p625": "13px",
    "1p875": "15px",
    "6p75": "54px",
    "4p5": "36px",
    "8p5": "68px",
    "9p5": "76px",
    "3p75": "30px",
    "7p75": "62px",
    "12p75": "102px",
    "11p75": "94px",
    "2p75": "22px",
    "3p25": "26px",
    "4p25": "34px",
    "4p75": "38px",
    negative: {
      1: "-8px",
      2: "-16px",
      3: "-24px",
      "0p5": "-4px",
      "0p25": "-2px",
      "0p75": "-6px",
      "0p125": "-1px",
      "0p375": "-3px",
      "0p625": "-5px",
      "0p825": "-7px",
      "1p75": "-14px",
      "1p625": "-13px",
      "1p5": "-12px",
      "1p375": "-11px",
      "1p875": "-15px",
      "1p25": "-10px",
      "1p125": "-9px",
      "3p75": "-30px",
      "3p5": "-28px",
      "3p25": "-26px",
      "2p75": "-22px",
      "2p5": "-20px",
      "2p25": "-18px",
    },
    "5p25": "42px",
    "6p25": "50px",
    "3p125": "25px",
    "8p75": "70px",
  },
  palette: {
    text: {
      primary: {
        light: "#1e2022",
        dark: "#edeeef",
      },
      secondary: {
        light: "#00050a9e",
        dark: "#f4faffb5",
      },
      disabled: {
        light: "#000f1d47",
        dark: "#e8f4fd5e",
      },
      tertiary: {
        light: "#00091275",
        dark: "#e8f4ff6e",
      },
      vibrant: {
        prominent: {
          light: "#bfbfbf",
          dark: "#bfbfbf",
        },
        primary: {
          light: "#1e2022",
          dark: "#edeeef",
        },
        secondary: {
          light: "#00050a9e",
          dark: "#f4faffb5",
        },
        tertiary: {
          light: "#00091275",
          dark: "#e8f4ff6e",
        },
        disabled: {
          light: "#000f1d47",
          dark: "#e8f4fd5e",
        },
      },
    },
    action: {
      hover: {
        light: "#6164670a",
        dark: "#b0b4b814",
      },
      selected: {
        light: "#61646714",
        dark: "#b0b4b829",
      },
      disabledBackground: {
        light: "#00254908",
        dark: "#f5f7f80d",
      },
      focus: {
        light: "#6164671f",
        dark: "#b0b4b81f",
      },
      disabled: {
        light: "#000f1d47",
        dark: "#e8f4fd5e",
      },
      active: {
        light: "#00050a9e",
        dark: "#f4faffb5",
      },
      activated: {
        light: "#6164671f",
        dark: "#b0b4b83d",
      },
      hoverOpacity: {
        light: 0.04,
        dark: 0.08,
      },
      selectedOpacity: {
        light: 0.08,
        dark: 0.16,
      },
      disabledOpacity: {
        light: 0.38,
        dark: 0.38,
      },
      focusOpacity: {
        light: 0.12,
        dark: 0.12,
      },
      activatedOpacity: {
        light: 0.12,
        dark: 0.24,
      },
      focusVisible: {
        light: "#6164674d",
        dark: "#b8bcc04d",
      },
      outlinedBorderOpacity: {
        light: 0.5,
        dark: 0.5,
      },
    },
    error: {
      1: {
        light: "#fffcfc",
        dark: "#0f0807",
      },
      2: {
        light: "#fff8f7",
        dark: "#1e1211",
      },
      3: {
        light: "#ffebe7",
        dark: "#3a130f",
      },
      4: {
        light: "#ffdbd4",
        dark: "#510f0b",
      },
      5: {
        light: "#ffccc3",
        dark: "#621611",
      },
      6: {
        light: "#ffbbb1",
        dark: "#73241d",
      },
      7: {
        light: "#f9a79b",
        dark: "#8c342b",
      },
      8: {
        light: "#f18b7e",
        dark: "#b5453a",
      },
      9: {
        light: "#f04438",
        dark: "#f04438",
      },
      10: {
        light: "#e23229",
        dark: "#e1342a",
      },
      11: {
        light: "#d5251e",
        dark: "#ff9081",
      },
      12: {
        light: "#621f19",
        dark: "#ffd2cb",
      },
      50: {
        light: "#ffebe7",
        dark: "#ffebe7",
      },
      100: {
        light: "#ffccc3",
        dark: "#ffccc3",
      },
      200: {
        light: "#ffbbb1",
        dark: "#ffbbb1",
      },
      300: {
        light: "#f9a79b",
        dark: "#f9a79b",
      },
      400: {
        light: "#ff9081",
        dark: "#ff9081",
      },
      500: {
        light: "#f04438",
        dark: "#f04438",
      },
      600: {
        light: "#e23229",
        dark: "#e23229",
      },
      700: {
        light: "#d5251e",
        dark: "#d5251e",
      },
      800: {
        light: "#621611",
        dark: "#621611",
      },
      900: {
        light: "#510f0b",
        dark: "#510f0b",
      },
      950: {
        light: "#3a130f",
        dark: "#3a130f",
      },
      lightest: {
        light: "#ffdbd4",
        dark: "#ffdbd4",
      },
      light: {
        light: "#ff9081",
        dark: "#ff9081",
      },
      main: {
        light: "#f04438",
        dark: "#f04438",
      },
      dark: {
        light: "#d5251e",
        dark: "#d5251e",
      },
      darkest: {
        light: "#73241d",
        dark: "#73241d",
      },
      contrast: {
        light: "#ffffff",
        dark: "#ffffff",
      },
      borderRegular: {
        light: "#f01f0063",
        dark: "#ff594787",
      },
      a2: {
        light: "#ff200008",
        dark: "#fd675117",
      },
      a1: {
        light: "#ff000003",
        dark: "#e4000008",
      },
      a11: {
        light: "#cf0800e0",
        dark: "#ff9081",
      },
      a8: {
        light: "#e41a0082",
        dark: "#fe5e4eb3",
      },
      a12: {
        light: "#510700e6",
        dark: "#ffd2cb",
      },
      a9: {
        light: "#ec1000c7",
        dark: "#fe473af0",
      },
      a5: {
        light: "#ff27003d",
        dark: "#fd2b1c5c",
      },
      a4: {
        light: "#ff2a012b",
        dark: "#fe1b0b4a",
      },
      a3: {
        light: "#ff2b0017",
        dark: "#fe371f33",
      },
      a7: {
        light: "#f01f0063",
        dark: "#ff594787",
      },
      a6: {
        light: "#ff21004f",
        dark: "#ff46356e",
      },
      a10: {
        light: "#dd0b00d6",
        dark: "#ff3a2fe0",
      },
      indicator: {
        light: "#f04438",
        dark: "#f04438",
      },
      track: {
        light: "#f04438",
        dark: "#f04438",
      },
      surface: {
        light: "#fff6f5cc",
        dark: "#331a1780",
      },
      solidHover: {
        light: "#e23229",
        dark: "#e1342a",
      },
      backgroundSoft: {
        light: "#ff2b0017",
        dark: "#fe371f33",
      },
      highContrast: {
        light: "#510700e6",
        dark: "#ffd2cb",
      },
      text: {
        light: "#cf0800e0",
        dark: "#ff9081",
      },
      borderSubtle: {
        light: "#ff21004f",
        dark: "#ff46356e",
      },
      solid: {
        light: "#f04438",
        dark: "#f04438",
      },
      backgroundSubtle: {
        light: "#ff200008",
        dark: "#fd675117",
      },
      backgroundSubtlest: {
        light: "#ff000003",
        dark: "#e4000008",
      },
      backgroundSoftHover: {
        light: "#ff2a012b",
        dark: "#fe1b0b4a",
      },
      backgroundSoftActive: {
        light: "#ff27003d",
        dark: "#fd2b1c5c",
      },
      borderStrong: {
        light: "#e41a0082",
        dark: "#fe5e4eb3",
      },
      onHighContrast: {
        light: "#ffd2cb",
        dark: "#621f19",
      },
    },
    warning: {
      1: {
        light: "#fdfdf8",
        dark: "#0a0a06",
      },
      2: {
        light: "#fdfde5",
        dark: "#171710",
      },
      3: {
        light: "#fdfda7",
        dark: "#25240e",
      },
      4: {
        light: "#f9f77a",
        dark: "#2f2e09",
      },
      5: {
        light: "#f2ee48",
        dark: "#3a390c",
      },
      6: {
        light: "#e3df43",
        dark: "#47461c",
      },
      7: {
        light: "#d3d04b",
        dark: "#59592c",
      },
      8: {
        light: "#bfba00",
        dark: "#717039",
      },
      9: {
        light: "#f6ef00",
        dark: "#fffd80",
      },
      10: {
        light: "#ece500",
        dark: "#ece500",
      },
      11: {
        light: "#827d00",
        dark: "#e6e475",
      },
      12: {
        light: "#3f3f18",
        dark: "#efefc1",
      },
      50: {
        light: "#fdfde5",
        dark: "#fdfde5",
      },
      100: {
        light: "#fdfda7",
        dark: "#fdfda7",
      },
      200: {
        light: "#f9f77a",
        dark: "#f9f77a",
      },
      300: {
        light: "#f6f476",
        dark: "#f6f476",
      },
      400: {
        light: "#f6ef00",
        dark: "#f6ef00",
      },
      500: {
        light: "#ece500",
        dark: "#ece500",
      },
      600: {
        light: "#827d00",
        dark: "#827d00",
      },
      700: {
        light: "#717039",
        dark: "#717039",
      },
      800: {
        light: "#59592c",
        dark: "#59592c",
      },
      900: {
        light: "#47461c",
        dark: "#47461c",
      },
      950: {
        light: "#3a390c",
        dark: "#3a390c",
      },
      lightest: {
        light: "#fdfda7",
        dark: "#fdfda7",
      },
      light: {
        light: "#f2ee48",
        dark: "#f2ee48",
      },
      main: {
        light: "#ece500",
        dark: "#ece500",
      },
      dark: {
        light: "#bfba00",
        dark: "#bfba00",
      },
      darkest: {
        light: "#827d00",
        dark: "#827d00",
      },
      contrast: {
        light: "#23230a",
        dark: "#23230a",
      },
      borderRegular: {
        light: "#c1bd00b5",
        dark: "#fffd7154",
      },
      a12: {
        light: "#2b2b00e8",
        dark: "#fefecdf0",
      },
      a11: {
        light: "#827d00",
        dark: "#fefc81e6",
      },
      a10: {
        light: "#ece500",
        dark: "#fffd7af5",
      },
      a1: {
        light: "#b7b70008",
        dark: "#890a0003",
      },
      a8: {
        light: "#bfba00",
        dark: "#fffb786b",
      },
      a6: {
        light: "#d9d400bd",
        dark: "#fdf64e40",
      },
      a5: {
        light: "#ede800b8",
        dark: "#fef51033",
      },
      a4: {
        light: "#f4f00085",
        dark: "#fbf00029",
      },
      a3: {
        light: "#fafa0059",
        dark: "#f7e7251f",
      },
      a2: {
        light: "#ecec001a",
        dark: "#f7e7600f",
      },
      a9: {
        light: "#f6ef00",
        dark: "#fffd80",
      },
      a7: {
        light: "#c1bd00b5",
        dark: "#fffd7154",
      },
      indicator: {
        light: "#f6ef00",
        dark: "#fffd80",
      },
      track: {
        light: "#f6ef00",
        dark: "#fffd80",
      },
      surface: {
        light: "#fdfddfcc",
        dark: "#25241580",
      },
      backgroundSubtle: {
        light: "#ecec001a",
        dark: "#f7e7600f",
      },
      highContrast: {
        light: "#2b2b00e8",
        dark: "#fefecdf0",
      },
      solidHover: {
        light: "#ece500",
        dark: "#f6f476",
      },
      solid: {
        light: "#f6ef00",
        dark: "#fffd80",
      },
      backgroundSoft: {
        light: "#fafa0059",
        dark: "#f7e7251f",
      },
      text: {
        light: "#827d00",
        dark: "#fefc81e6",
      },
      borderSubtle: {
        light: "#d9d400bd",
        dark: "#fdf64e40",
      },
      backgroundSubtlest: {
        light: "#b7b70008",
        dark: "#890a0003",
      },
      backgroundSoftHover: {
        light: "#f4f00085",
        dark: "#fbf00029",
      },
      backgroundSoftActive: {
        light: "#ede800b8",
        dark: "#fef51033",
      },
      borderStrong: {
        light: "#bfba00",
        dark: "#fffb786b",
      },
      onHighContrast: {
        light: "#efefc1",
        dark: "#3f3f18",
      },
    },
    success: {
      1: {
        light: "#f9fefd",
        dark: "#050c0a",
      },
      2: {
        light: "#f1fcf9",
        dark: "#0f1b18",
      },
      3: {
        light: "#dafaf2",
        dark: "#0d2d27",
      },
      4: {
        light: "#c2f6e9",
        dark: "#043b32",
      },
      5: {
        light: "#aaeede",
        dark: "#0b483e",
      },
      6: {
        light: "#90e2d0",
        dark: "#16574c",
      },
      7: {
        light: "#6ed2be",
        dark: "#1e695c",
      },
      8: {
        light: "#26bea6",
        dark: "#217f6f",
      },
      9: {
        light: "#15b79f",
        dark: "#15b79f",
      },
      10: {
        light: "#00ab94",
        dark: "#00ab94",
      },
      11: {
        light: "#007b67",
        dark: "#47d4bb",
      },
      12: {
        light: "#0a443b",
        dark: "#aaf0e0",
      },
      50: {
        light: "#dafaf2",
        dark: "#dafaf2",
      },
      100: {
        light: "#aaeede",
        dark: "#aaeede",
      },
      200: {
        light: "#90e2d0",
        dark: "#90e2d0",
      },
      300: {
        light: "#6ed2be",
        dark: "#6ed2be",
      },
      400: {
        light: "#47d4bb",
        dark: "#47d4bb",
      },
      500: {
        light: "#15b79f",
        dark: "#15b79f",
      },
      600: {
        light: "#007b67",
        dark: "#007b67",
      },
      700: {
        light: "#16574c",
        dark: "#16574c",
      },
      800: {
        light: "#0b483e",
        dark: "#0b483e",
      },
      900: {
        light: "#043b32",
        dark: "#043b32",
      },
      950: {
        light: "#0d2d27",
        dark: "#0d2d27",
      },
      lightest: {
        light: "#c2f6e9",
        dark: "#c2f6e9",
      },
      light: {
        light: "#47d4bb",
        dark: "#47d4bb",
      },
      main: {
        light: "#15b79f",
        dark: "#15b79f",
      },
      dark: {
        light: "#007b67",
        dark: "#007b67",
      },
      darkest: {
        light: "#16574c",
        dark: "#16574c",
      },
      contrast: {
        light: "#ffffff",
        dark: "#ffffff",
      },
      borderRegular: {
        light: "#00b08d91",
        dark: "#3fffdc63",
      },
      a11: {
        light: "#007b67",
        dark: "#53fee0d4",
      },
      a1: {
        light: "#00d5aa05",
        dark: "#00b40003",
      },
      a9: {
        light: "#00b196eb",
        dark: "#1afedcb5",
      },
      a12: {
        light: "#003c33f5",
        dark: "#b4feedf0",
      },
      a8: {
        light: "#00b397d9",
        dark: "#3bffdc7a",
      },
      a5: {
        light: "#00cc9c54",
        dark: "#11fed440",
      },
      a4: {
        light: "#00daa43d",
        dark: "#00ffce33",
      },
      a2: {
        light: "#00c9920d",
        dark: "#5efbc412",
      },
      a7: {
        light: "#00b08d91",
        dark: "#3fffdc63",
      },
      a6: {
        light: "#00bd9470",
        dark: "#32fdd752",
      },
      a10: {
        light: "#00ab94",
        dark: "#00ffdba8",
      },
      a3: {
        light: "#00dda626",
        dark: "#25fbcc26",
      },
      indicator: {
        light: "#15b79f",
        dark: "#15b79f",
      },
      track: {
        light: "#15b79f",
        dark: "#15b79f",
      },
      surface: {
        light: "#eefbf8cc",
        dark: "#152c2580",
      },
      highContrast: {
        light: "#003c33f5",
        dark: "#b4feedf0",
      },
      text: {
        light: "#007b67",
        dark: "#53fee0d4",
      },
      solid: {
        light: "#15b79f",
        dark: "#15b79f",
      },
      backgroundSubtle: {
        light: "#00c9920d",
        dark: "#5efbc412",
      },
      backgroundSoft: {
        light: "#00dda626",
        dark: "#25fbcc26",
      },
      solidHover: {
        light: "#00ab94",
        dark: "#00ab94",
      },
      borderSubtle: {
        light: "#00bd9470",
        dark: "#32fdd752",
      },
      backgroundSubtlest: {
        light: "#00d5aa05",
        dark: "#00b40003",
      },
      backgroundSoftHover: {
        light: "#00daa43d",
        dark: "#00ffce33",
      },
      backgroundSoftActive: {
        light: "#00cc9c54",
        dark: "#11fed440",
      },
      borderStrong: {
        light: "#00b397d9",
        dark: "#3bffdc7a",
      },
      onHighContrast: {
        light: "#aaf0e0",
        dark: "#0a443b",
      },
    },
    background: {
      primary: {
        light: "#ffffff",
        dark: "#090a0b",
      },
      level1: {
        light: "#f8f9fa",
        dark: "#161718",
      },
      level2: {
        light: "#eff0f2",
        dark: "#202223",
      },
      level3: {
        light: "#e7e8ea",
        dark: "#27292b",
      },
      grouped: {
        primary: {
          light: "#f8f9fa",
          dark: "#161718",
        },
        secondary: {
          light: "#ffffff",
          dark: {
            light: "#f8f9fa",
            dark: "#161718",
          },
        },
        tertiary: {
          light: "#f8f9fa",
          dark: "#161718",
        },
      },
      paper: {
        light: "#ffffff",
        dark: "#090a0b",
      },
      raisedOverlay: {
        light: "#ffffff00",
        dark: "#00000000",
      },
      secondary: {
        light: "#f8f9fa",
        dark: "#161718",
      },
      tertiary: {
        light: "#ffffff",
        dark: {
          light: "#eff0f2",
          dark: "#202223",
        },
      },
      paperOverlay: {
        light: "#ffffff00",
        dark: "#00000000",
      },
    },
    white: {
      light: "#ffffff",
      dark: "#ffffff",
    },
    black: {
      light: "#000000",
      dark: "#000000",
    },
    overlay: {
      lightToDark: {
        light: "#ffffff80",
        dark: "#00000080",
      },
      default: {
        light: "#00000040",
        dark: "#00000080",
      },
    },
    chart: {
      dataset1: {
        light: "#7560ff",
        dark: "#7560ff",
      },
      dataset2: {
        light: "#9c99ff",
        dark: "#9c99ff",
      },
      dataset3: {
        light: "#b6b7ff",
        dark: "#b6b7ff",
      },
      dataset4: {
        light: "#caccff",
        dark: "#caccff",
      },
      dataset5: {
        light: "#d9dbff",
        dark: "#d9dbff",
      },
      dataset6: {
        light: "#e5e6ff",
        dark: "#e5e6ff",
      },
      chartDatasetPositive: {
        light: "#26bea6",
        dark: "#217f6f",
      },
      datasetNegative: {
        light: "#f18b7e",
        dark: "#b5453a",
      },
      datasetNeutral: {
        light: "#b8bcc0",
        dark: "#5c6165",
      },
      datasetWarning: {
        light: "#bfba00",
        dark: "#717039",
      },
    },
    divider: {
      regular: {
        light: "#0010300f",
        dark: "#ebf6f71a",
      },
      opaque: {
        light: "#eff0f2",
        dark: "#202223",
      },
      vibrant: {
        light: "#0010300f",
        dark: "#ebf6f71a",
      },
    },
    card: {
      border: {
        light: "#0010300f",
        dark: "#ebf6f71a",
      },
      outlinedBorder: {
        light: "#0010300f",
        dark: "#ebf6f71a",
      },
    },
    mode: {
      light: "Light",
      dark: "Dark",
    },
    fill: {
      secondary: {
        light: "#000b2017",
        dark: "#eaf3fb21",
      },
      quaternary: {
        light: "#00254908",
        dark: "#f5f7f80d",
      },
      tertiary: {
        light: "#0010300f",
        dark: "#ebf6f71a",
      },
      primary: {
        light: "#00102021",
        dark: "#f5fdfe29",
      },
      quinary: {
        light: "#00005503",
        dark: "#00000000",
      },
      vibrant: {
        primary: {
          light: "#00102021",
          dark: "#f5fdfe29",
        },
        secondary: {
          light: "#000b2017",
          dark: "#eaf3fb21",
        },
        tertiary: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        quaternary: {
          light: "#00254908",
          dark: "#f5f7f80d",
        },
        quinary: {
          light: "#00005503",
          dark: "#00000000",
        },
      },
    },
    segmentedControl: {
      selectionBackground: {
        light: "#ffffff",
        dark: "#090a0b",
      },
    },
    field: {
      outlined: {
        borderEnabled: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        borderHover: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        borderDisabled: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        borderActive: {
          light: "#0800ff66",
          dark: "#7563fec4",
        },
        borderError: {
          light: "#e41a0082",
          dark: "#fe5e4eb3",
        },
        backgroundDisabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        backgroundEnabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        backgroundHover: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        backgroundActive: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        backgroundError: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      soft: {
        backgroundEnabled: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        backgroundHover: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        backgroundDisabled: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        backgroundActive: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        borderFocused: {
          light: "#0800ff66",
          dark: "#7563fec4",
        },
        borderError: {
          light: "#e41a0082",
          dark: "#fe5e4eb3",
        },
        borderDisabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        borderEnabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        borderHover: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        backgroundError: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
      },
      borderless: {
        backgroundDisabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        backgroundEnabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        backgroundHover: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        backgroundActive: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        borderDisabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        borderEnabled: {
          light: "#ffffff00",
          dark: "#00000000",
        },
        borderHover: {
          light: "#0010300f",
          dark: "#ebf6f71a",
        },
        borderActive: {
          light: "#0800ff66",
          dark: "#7563fec4",
        },
        borderError: {
          light: "#e41a0082",
          dark: "#fe5e4eb3",
        },
        backgroundError: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
    },
    track: {
      light: "#000b2017",
      dark: "#eaf3fb21",
    },
    thumb: {
      light: "#ffffff",
      dark: "#ffffff",
    },
    surface: {
      light: "#ffffffd9",
      dark: "#00000040",
    },
    avatar: {
      background: {
        light: "#0010300f",
        dark: "#ebf6f71a",
      },
    },
    transparent: {
      light: "#ffffff00",
      dark: "#00000000",
    },
    checkbox: {
      border: {
        light: "#000f1e33",
        dark: "#edf6ff42",
      },
    },
    helloBar: {
      background: {
        light: "#1e2022",
        dark: "#edeeef",
      },
      text: {
        light: "#edeeef",
        dark: "#1e2022",
      },
    },
    lightToDark: {
      light: "#ffffff",
      dark: "#1e2022",
    },
    shadow: {
      xs: {
        light: "#0000000a",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      sm: {
        light: "#0000000f",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      md: {
        light: "#00000014",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      lg: {
        light: "#0000001a",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      xl: {
        light: "#00000026",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      "2xl": {
        light: "#0000002e",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
    },
    list: {
      background: {
        light: "#00254908",
        dark: "#f5f7f80d",
      },
    },
  },
  base: {
    button: {
      medium: {
        size: "40px",
        radius: "12px",
        paddingHorizontal: "14px",
        paddingVertical: "6px",
        spaceBetween: "4px",
        labelPadding: "2px",
      },
      xsmall: {
        size: "28px",
        radius: "10px",
        paddingHorizontal: "8px",
        paddingVertical: "2px",
        labelPadding: "2px",
        spaceBetween: "1px",
      },
      small: {
        size: "32px",
        radius: "10px",
        paddingHorizontal: "10px",
        paddingVertical: "4px",
        labelPadding: "2px",
        spaceBetween: "2px",
      },
      large: {
        size: "48px",
        radius: "16px",
        paddingHorizontal: "18px",
        paddingVertical: "8px",
        labelPadding: "2px",
        spaceBetween: "4px",
      },
      minWidth: "64px",
    },
    list: {
      item: {
        radiusRounded: "20px",
        minHeight: "48px",
        minHeightDense: "40px",
        paddingHorizontal: "16px",
        leadingMinWidth: "24px",
        spaceBetween: "16px",
        paddingVertical: "12px",
        paddingVerticalDense: "10px",
        trailingMinWidth: "20px",
      },
      radius: "26px",
    },
    divider: {
      middleMargin: "16px",
      inset: "20px",
    },
    thumbnail: {
      sizeLarge: "60px",
      sizeMedium: "40px",
      sizeSmall: "32px",
      size2xs: "24px",
      sizeXlarge: "80px",
      sizeXsmall: "28px",
      radiusXsmall: "9.33px",
      radiusSmall: "10.67px",
      radiusMedium: "13.33px",
      radiusLarge: "20px",
      radiusXlarge: "26.67px",
      radius2xs: "8px",
      size2xl: "120px",
      radius2xl: "40px",
      radius: "33.33%",
      size3xs: "18px",
      radius3xs: "6px",
    },
    chip: {
      medium: {
        size: "34px",
        labelPadding: "9px",
        leadingPaddingLeft: "5px",
        labelTextPadding: "2px",
        labelSpaceBetween: "4px",
        leadingMarginRight: "-4px",
      },
      small: {
        size: "24px",
        leadingPaddingLeft: "3px",
        labelPadding: "5px",
        labelSpaceBetween: "1px",
        labelTextPadding: "3px",
        leadingMarginRight: "-4px",
      },
      large: {
        size: "38px",
        labelPadding: "12px",
        leadingPadding: "7px",
        labelSpaceBetween: "6px",
        labelTextPadding: "2px",
        leadingMarginRight: "-4px",
      },
      radius: "9999px",
    },
    tooltip: {
      radius: "12px",
    },
    toast: {
      radius: "20px",
      minHeight: "48px",
      minWidth: "200px",
      maxWidth: "444px",
    },
    alert: {
      radius: "20px",
    },
    field: {
      radius: "12px",
      medium: {
        height: "40px",
        paddingVertical: "9px",
      },
      small: {
        height: "32px",
        paddingVertical: "6px",
      },
      leadingMinWidth: "24px",
      spaceBetween: "12px",
      trailingMinWidth: "24px",
      paddingHorizontal: "12px",
      borderWidth: "1px",
      borderWidthFocused: "2px",
    },
    accordion: {
      rounded: {
        radius: "16px",
        gap: "8px",
      },
      summary: {
        minHeight: "48px",
        paddingHorizontal: "16px",
        paddingVertical: "12px",
        spaceBetween: "16px",
        leadingMinWidth: "24px",
      },
      details: {
        paddingTop: "8px",
        paddingBottom: "16px",
        paddingHorizontal: "16px",
      },
    },
    container: {
      widthXs: "444px",
      widthSm: "600px",
      widthMd: "900px",
      widthLg: "1200px",
      widthXl: "1400px",
      widthMax: "1680px",
    },
    page: {
      container: {
        paddingLg: "40px",
        paddingMd: "32px",
        paddingSm: "24px",
        paddingXs: "16px",
        paddingXl: "72px",
        paddingMax: "72px",
        gapXs: "16px",
        gapSm: "24px",
        gapMd: "24px",
        gapLg: "24px",
        gapXl: "32px",
        gapMax: "32px",
      },
      main: {
        paddingTopXs: "0px",
        paddingTopSm: "0px",
        paddingTopMd: "0px",
        paddingTopLg: "0px",
        paddingTopXl: "0px",
        paddingTopMax: "0px",
        paddingBottomXs: "16px",
        paddingBottomSm: "40px",
        paddingBottomMd: "40px",
        paddingBottomLg: "80px",
        paddingBottomXl: "80px",
        paddingBottomMax: "80px",
      },
      header: {
        paddingBottomXs: "0px",
        paddingTopMax: "20px",
        paddingTopXl: "20px",
        paddingTopLg: "20px",
        paddingTopMd: "20px",
        paddingTopSm: "20px",
        paddingTopXs: "0px",
        paddingBottomSm: "0px",
        paddingBottomMd: "0px",
        paddingBottomLg: "0px",
        paddingBottomXl: "0px",
        paddingBottomMax: "0px",
      },
    },
    menu: {
      list: {
        padding: "10px",
      },
      minWidthCompact: "200px",
      item: {
        minHeight: "40px",
        paddingVertical: "8px",
        radius: "20px",
        leadingMinWidth: "24px",
        spaceBetween: "12px",
        paddingHorizontal: "12px",
        trailingMinWidth: "24px",
      },
      maxWidthCompact: "300px",
      contentPaddingLarge: "24px",
      maxHeightCompact: "400px",
    },
    card: {
      radius: "26px",
      contentPadding: "24px",
    },
    tabs: {
      height: "48px",
    },
    slider: {
      height: "44px",
      heightSmall: "36px",
    },
    toolbar: {
      gap: "16px",
      buttonGroup: {
        gap: "8px",
        padding: "4px",
      },
      minHeight: "40px",
    },
    helloBar: {
      minHeight: "48px",
      maxWidth: "900px",
    },
    sidebar: {
      item: {
        radius: "20px",
        paddingHorizontal: "12px",
        paddingVertical: "8px",
        spaceBetween: "12px",
        minHeight: "40px",
        leadingMinWidth: "24px",
        nestedIndent: "20px",
        trailingMinWidth: "24px",
        gap: "8px",
      },
      width: "280px",
      logoMaxWidth: "120px",
      logoMaxHeight: "32px",
    },
    dialog: {
      contentPadding: "24px",
      widthXs: "444px",
      widthSm: "600px",
      widthMd: "900px",
      widthLg: "1200px",
      widthXl: "1400px",
      widthMax: "1680px",
      fullscreenContentPadding: "20px",
      radius: "38px",
    },
    swipeableDrawer: {
      contentPadding: "20px",
      radiusMediumDetent: "48px",
      radiusLargeDetent: "38px",
    },
    drawer: {
      contentPadding: "20px",
      temporaryDrawerWidth: "600px",
      permamentDrawerWidth: "450px",
    },
    confirmDialog: {
      width: "300px",
    },
    code: {
      radius: "4px",
      paddingLeft: "0.25em",
      paddingRight: "0.25em",
      paddingBottom: "0.075em",
      lineHeight: "1.25px",
      paddingTop: "0",
      fontSizeAdjust: "0.95 * 0.95",
    },
    mobileAppHeader: {
      controlsHeight: "44px",
    },
    surface: {
      radiusSheet: "38px",
      radiusControls: "9999px",
    },
    toggleButtonGroup: {
      gap: "8px",
    },
    tabBar: {
      sizeLarge: "54px",
      sizeMedium: "48px",
      sizeSmall: "32px",
      height: "62px",
    },
  },
  typography: {
    fontFamily: {
      text: "Sawton Industrial",
      code: "Inconsolata",
      icon: "Font Awesome 7 Pro",
    },
    fontWeight: {
      light: "light",
      regular: "regular",
      medium: "medium",
      text: "light",
      textSemibold: "regular",
      textBold: "medium",
      button: "regular",
      heading: "regular",
    },
    lineHeight: {
      1: "16px",
      2: "20px",
      3: "24px",
      4: "26px",
      5: "28px",
      6: "30px",
      7: "34px",
      8: "40px",
      9: "60px",
      "1p5": "18px",
      "2p5": "22px",
      "3p5": "25px",
      "0p5": "12px",
      "0p75": "14px",
      "5p5": "29px",
    },
    letterSpacing: {
      1: "0.04px",
      2: "0px",
      3: "0px",
      4: "-0.04px",
      5: "-0.08px",
      6: "-0.1px",
      7: "-0.12px",
      8: "-0.16px",
      9: "-0.4px",
      "1p5": "0.02px",
      "2p5": "0px",
      "3p5": "-0.02px",
      "0p5": "0.04px",
      display: "-0.8px",
      "0p75": "0.04px",
      "5p5": "-0.09px",
    },
    fontSize: {
      1: "12px",
      2: "14px",
      3: "16px",
      4: "18px",
      5: "20px",
      6: "24px",
      7: "28px",
      8: "34px",
      9: "60px",
      "1p5": "13px",
      "2p5": "15px",
      "3p5": "17px",
      "0p5": "10px",
      display: "120px",
      "0p75": "11px",
      "5p5": "22px",
    },
  },
  color: {
    red: {
      light: {
        1: "#fffcfc",
        2: "#fff8f7",
        3: "#ffebe7",
        4: "#ffdbd4",
        5: "#ffccc3",
        6: "#ffbbb1",
        7: "#f9a79b",
        8: "#f18b7e",
        9: "#f04438",
        10: "#e23229",
        11: "#d5251e",
        12: "#621f19",
        a10: "#dd0b00d6",
        a9: "#ec1000c7",
        a7: "#f01f0063",
        a11: "#cf0800e0",
        a1: "#ff000003",
        surface: "#fff6f5cc",
        contrast: "#ffffff",
        a12: "#510700e6",
        a8: "#e41a0082",
        a4: "#ff2a012b",
        a5: "#ff27003d",
        a6: "#ff21004f",
        a3: "#ff2b0017",
        a2: "#ff200008",
      },
      dark: {
        1: "#0f0807",
        2: "#1e1211",
        3: "#3a130f",
        4: "#510f0b",
        5: "#621611",
        6: "#73241d",
        7: "#8c342b",
        8: "#b5453a",
        9: "#f04438",
        10: "#e1342a",
        11: "#ff9081",
        12: "#ffd2cb",
        a12: "#ffd2cb",
        a4: "#fe1b0b4a",
        a3: "#fe371f33",
        a2: "#fd675117",
        a8: "#fe5e4eb3",
        a10: "#ff3a2fe0",
        a9: "#fe473af0",
        a11: "#ff9081",
        a7: "#ff594787",
        a6: "#ff46356e",
        a1: "#e4000008",
        surface: "#331a1780",
        a5: "#fd2b1c5c",
        contrast: "#ffffff",
      },
    },
    green: {
      light: {
        1: "#f9fefd",
        2: "#f1fcf9",
        3: "#dafaf2",
        4: "#c2f6e9",
        5: "#aaeede",
        6: "#90e2d0",
        7: "#6ed2be",
        8: "#26bea6",
        9: "#15b79f",
        10: "#00ab94",
        11: "#007b67",
        12: "#0a443b",
        surface: "#eefbf8cc",
        a11: "#007b67",
        a10: "#00ab94",
        a9: "#00b196eb",
        a7: "#00b08d91",
        a6: "#00bd9470",
        a4: "#00daa43d",
        a2: "#00c9920d",
        a1: "#00d5aa05",
        contrast: "#ffffff",
        a5: "#00cc9c54",
        a3: "#00dda626",
        a8: "#00b397d9",
        a12: "#003c33f5",
      },
      dark: {
        1: "#050c0a",
        2: "#0f1b18",
        3: "#0d2d27",
        4: "#043b32",
        5: "#0b483e",
        6: "#16574c",
        7: "#1e695c",
        8: "#217f6f",
        9: "#15b79f",
        10: "#00ab94",
        11: "#47d4bb",
        12: "#aaf0e0",
        a12: "#b4feedf0",
        a11: "#53fee0d4",
        a4: "#00ffce33",
        a10: "#00ffdba8",
        a5: "#11fed440",
        a3: "#25fbcc26",
        a6: "#32fdd752",
        a8: "#3bffdc7a",
        a9: "#1afedcb5",
        a7: "#3fffdc63",
        a2: "#5efbc412",
        a1: "#00b40003",
        contrast: "#ffffff",
        surface: "#152c2580",
      },
    },
    yellow: {
      dark: {
        1: "#0a0a06",
        2: "#171710",
        3: "#25240e",
        4: "#2f2e09",
        5: "#3a390c",
        6: "#47461c",
        7: "#59592c",
        8: "#717039",
        9: "#fffd80",
        10: "#f6f476",
        11: "#e6e475",
        12: "#efefc1",
        a12: "#fefecdf0",
        a11: "#fefc81e6",
        a10: "#fffd7af5",
        a9: "#fffd80",
        a8: "#fffb786b",
        a6: "#fdf64e40",
        a5: "#fef51033",
        a4: "#fbf00029",
        a3: "#f7e7251f",
        a2: "#f7e7600f",
        a1: "#890a0003",
        surface: "#25241580",
        a7: "#fffd7154",
        contrast: "#23230a",
      },
      light: {
        1: "#fdfdf8",
        2: "#fdfde5",
        3: "#fdfda7",
        4: "#f9f77a",
        5: "#f2ee48",
        6: "#e3df43",
        7: "#d3d04b",
        8: "#bfba00",
        9: "#f6ef00",
        10: "#ece500",
        11: "#827d00",
        12: "#3f3f18",
        a10: "#ece500",
        a3: "#fafa0059",
        a9: "#f6ef00",
        surface: "#fdfddfcc",
        a5: "#ede800b8",
        a12: "#2b2b00e8",
        contrast: "#23230a",
        a2: "#ecec001a",
        a7: "#c1bd00b5",
        a4: "#f4f00085",
        a1: "#b7b70008",
        a6: "#d9d400bd",
        a11: "#827d00",
        a8: "#bfba00",
      },
    },
    black: {
      a8: "#00000099",
      a5: "#0000004d",
      a4: "#00000033",
      a3: "#00000026",
      a1: "#0000000d",
      a9: "#000000b3",
      a7: "#00000080",
      a12: "#000000f2",
      a2: "#0000001a",
      a11: "#000000e6",
      a6: "#00000066",
      a10: "#000000cc",
    },
    white: {
      a12: "#fffffff2",
      a11: "#ffffffe6",
      a10: "#ffffffcc",
      a9: "#ffffffb3",
      a7: "#ffffff80",
      a3: "#ffffff26",
      a4: "#ffffff33",
      a1: "#ffffff0d",
      a8: "#ffffff99",
      a2: "#ffffff1a",
      a5: "#ffffff4d",
      a6: "#ffffff66",
    },
  },
  breakpoint: {
    "2xl": "1640px",
    xl: "1280px",
    sm: "520px",
    lg: "1024px",
    md: "768px",
    xs: "0px",
  },
  radius: {
    0: "0px",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "48px",
    7: "56px",
    8: "64px",
    "1p5": "12px",
    "0p25": "2px",
    "0p75": "6px",
    "3p5": "28px",
    "1p25": "10px",
    "0p5": "4px",
    "2p25": "18px",
    "1p75": "14px",
    "2p5": "20px",
    "4p5": "36px",
    "5p5": "44px",
    full: "9999px",
    factor: "8px",
    "4p75": "38px",
    "2p75": "22px",
    "3p25": "26px",
    "3p75": "30px",
    "4p25": "34px",
    "5p25": "42px",
    "5p75": "46px",
    "6p25": "50px",
    "6p5": "52px",
    "6p75": "54px",
    "7p25": "58px",
    "7p5": "60px",
    "7p75": "62px",
    "0p875": "7px",
    "1p875": "15px",
    "1p125": "9px",
    "0p125": "1px",
    "0p375": "3px",
    "0p625": "5px",
    "1p375": "11px",
  },
  theme: {
    color: {
      backgroundDark: "#090a0b",
      backgroundLight: "#ffffff",
      grayDark: "#a0a4a8",
      grayLight: "#a0a4a8",
      accentDark: "#7560ff",
      accentLight: "#7560ff",
      greenLight: "#15b79f",
      greenDark: "#15b79f",
      redLight: "#f04438",
      redDark: "#f04438",
      yellowLight: "#fffd80",
      yellowDark: "#fffd80",
    },
  },
  responsive: {
    breakpoint: "xl",
  },
  effect: {
    blur: {
      glass: "30px",
      material: "100px",
      control: "30px",
      backdrop: "30px",
      scrollEdgeEffectSoft: "10px",
      scrollEdgeEffectBase: "60px",
    },
    blurRadius: {
      10: "10px",
      20: "20px",
      30: "30px",
      40: "40px",
      50: "50px",
      60: "60px",
      70: "70px",
      80: "80px",
      90: "90px",
      100: "100px",
    },
  },
  typographyStyles: {
    h1: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "60px",
      lineHeight: "60px",
      letterSpacing: "-0.4px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h2: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "34px",
      lineHeight: "40px",
      letterSpacing: "-0.16px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h3: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "28px",
      lineHeight: "34px",
      letterSpacing: "-0.12px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h4: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "24px",
      lineHeight: "30px",
      letterSpacing: "-0.1px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h5: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "-0.08px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h6: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "18px",
      lineHeight: "26px",
      letterSpacing: "-0.04px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    subtitle1: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    subtitle2: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    body1: {
      fontFamily: "Sawton Industrial",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    body2: {
      fontFamily: "Sawton Industrial",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    code1: {
      fontFamily: "Inconsolata",
      fontWeight: 500,
      fontStyle: "normal",
      fontSize: "14.4399995803833px",
      lineHeight: "18px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    code2: {
      fontFamily: "Inconsolata",
      fontWeight: 500,
      fontStyle: "normal",
      fontSize: "12.635000228881836px",
      lineHeight: "16px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    caption: {
      fontFamily: "Sawton Industrial",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.04px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    overline: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "30px",
      letterSpacing: "0.04px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "UPPER",
    },
    button: {
      fontFamily: "Sawton Industrial",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "18px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    actionCard: {
      title: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      description: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    alert: {
      title: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      description: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    avatar: {
      label3xs: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.04px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label2xs: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelXsmall: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelSmall: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelMedium: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "20px",
        lineHeight: "28px",
        letterSpacing: "-0.08px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelLarge: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "28px",
        lineHeight: "34px",
        letterSpacing: "-0.12px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelXlarge: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "28px",
        lineHeight: "34px",
        letterSpacing: "-0.12px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    badge: {
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.04px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    chart: {
      axisLabel: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.04px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    chip: {
      smallLabel: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.04px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      mediumLabel: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0.02px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      largeLabel: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    confirmDialog: {
      title: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      description: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    field: {
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      value: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "22px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      valueSmall: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      helper: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    list: {
      subheader: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelDense: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      secondary: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    menu: {
      subheader: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0.02px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "22px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      secondary: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0.02px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      quickActionLabel: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "16px",
        letterSpacing: "0.02px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    pageHeader: {
      title: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "28px",
        lineHeight: "34px",
        letterSpacing: "-0.12px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      subtitle: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    segmentedControl: {
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    sidebar: {
      subheader: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0.02px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "22px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      secondary: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0.02px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    tabs: {
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    tabBar: {
      stackedLabel: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "10px",
        lineHeight: "12px",
        letterSpacing: "0.04px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    table: {
      head: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      cell: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    title: {
      title2Line: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "18px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      title: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "17px",
        lineHeight: "22px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      titleLarge: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "28px",
        lineHeight: "34px",
        letterSpacing: "-0.12px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      titleLargeCompact: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "20px",
        lineHeight: "28px",
        letterSpacing: "-0.08px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      subtitle: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "12px",
        lineHeight: "14px",
        letterSpacing: "0.04px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      subtitleLarge: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    toast: {
      title: {
        fontFamily: "Sawton Industrial",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      description: {
        fontFamily: "Sawton Industrial",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
  },
  gridStyles: {
    breakpoint: {
      xs: {
        columnCount: 12,
        columnGap: "16px",
      },
      sm: {
        columnCount: 12,
        columnGap: "24px",
      },
      md: {
        columnCount: 12,
        columnGap: "24px",
      },
      lg: {
        columnCount: 12,
        columnGap: "24px",
      },
      xl: {
        columnCount: 12,
        columnGap: "32px",
      },
      max: {
        columnCount: 12,
        columnGap: "32px",
      },
    },
  },
  effectStyles: {
    shadow: {
      paper: [
        {
          inset: false,
          color: "#0000000f",
          offsetX: "0px",
          offsetY: "2px",
          blur: "8px",
          spread: "1px",
        },
      ],
      xs: [
        {
          inset: false,
          color: "#0000000a",
          offsetX: "0px",
          offsetY: "1px",
          blur: "5px",
          spread: "1px",
        },
      ],
      sm: [
        {
          inset: false,
          color: "#0000000f",
          offsetX: "0px",
          offsetY: "2px",
          blur: "8px",
          spread: "1px",
        },
      ],
      md: [
        {
          inset: false,
          color: "#00000014",
          offsetX: "0px",
          offsetY: "4px",
          blur: "16px",
          spread: "1px",
        },
      ],
      lg: [
        {
          inset: false,
          color: "#0000001a",
          offsetX: "0px",
          offsetY: "8px",
          blur: "24px",
          spread: "1px",
        },
      ],
      xl: [
        {
          inset: false,
          color: "#00000026",
          offsetX: "0px",
          offsetY: "12px",
          blur: "48px",
          spread: "1px",
        },
      ],
      "2xl": [
        {
          inset: false,
          color: "#0000002e",
          offsetX: "0px",
          offsetY: "16px",
          blur: "64px",
          spread: "1px",
        },
      ],
    },
  },
};
